import { useState } from 'react';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ContactForm = ({ propertyId, propertyTitle }) => {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    phone: '',
    message: propertyTitle ? `Je suis intéressé(e) par: ${propertyTitle}` : ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/contact`, {
        ...formData,
        property_id: propertyId
      });
      toast.success('Message envoyé avec succès!');
      setFormData({ full_name: '', email: '', phone: '', message: '' });
    } catch (error) {
      toast.error('Erreur lors de l\'envoi du message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} data-testid="contact-form" className="space-y-6 bg-white border border-border p-8">
      <h3 className="text-3xl font-serif tracking-tight mb-6">Contactez-nous</h3>
      
      <div>
        <Input
          data-testid="contact-name"
          type="text"
          placeholder="Nom complet"
          value={formData.full_name}
          onChange={(e) => setFormData({...formData, full_name: e.target.value})}
          required
          className="border-bottom-input"
        />
      </div>

      <div>
        <Input
          data-testid="contact-email"
          type="email"
          placeholder="Email"
          value={formData.email}
          onChange={(e) => setFormData({...formData, email: e.target.value})}
          required
          className="border-bottom-input"
        />
      </div>

      <div>
        <Input
          data-testid="contact-phone"
          type="tel"
          placeholder="Téléphone"
          value={formData.phone}
          onChange={(e) => setFormData({...formData, phone: e.target.value})}
          required
          className="border-bottom-input"
        />
      </div>

      <div>
        <Textarea
          data-testid="contact-message"
          placeholder="Votre message"
          value={formData.message}
          onChange={(e) => setFormData({...formData, message: e.target.value})}
          required
          rows={5}
          className="border-border"
        />
      </div>

      <Button
        data-testid="contact-submit"
        type="submit"
        disabled={loading}
        className="w-full btn-primary bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8 py-6 text-sm uppercase tracking-widest font-semibold"
      >
        {loading ? 'Envoi...' : 'Envoyer le message'}
      </Button>
    </form>
  );
};